<svelte:options accessors={true}/>
<script>
    import HRImport from './../../components/HR/HRImport.svelte';
	import JobRoles from './../../components/HR/JobRoles.svelte';
    import { onMount } from 'svelte';
    import ReportsService from "../../services/reports.service";
    import EditableCell from "../../components/EditableCell.svelte";
    import AuthService from '../../services/auth.service.js';
    import Loader from "../../components/Loader.svelte";
    import HRService from '../../services/hr.service.js';
    import ExportService from '../../services/export.service'
    //Sorting and pagination
    import EntriesSelector from './../../components/sorting/EntriesSelector.svelte';
    import Search from './../../components/sorting/Search.svelte';
    import Pagination from './../../components/sorting/Pagination.svelte';

    let page, loading = false, reportData, errorMessage,
        currentPage = 0, search = "", sortBy = "id",
        order = true, entries = 100, totalElements = 0,
        censusToDelete, currentCensus = {};

    export let user, params, loadingExport = false;;

    //Catch when a value change
    $: loadData(params, search, entries, currentPage, order, sortBy, entries);

    onMount(() => {
        loadData();
    });

    const headers = [
        {title: "employee #", key: "employee_id", customClass : "", editable: true, type: "text", format: 7, selectOptionsKey: "", width: 100, exportWidth: 20},
        {title: "name", key: "name", customClass : "", editable: true, type: "text", format: 7, selectOptionsKey: "", width: 150, exportWidth: 20},
        {title: "email", key: "email", customClass : "", editable: true, type: "text", format: 7, selectOptionsKey: "", width: 200, exportWidth: 20},
        {title: "department", key: "department", customClass : "", editable: true, type: "select", format: 7, selectOptionsKey: "departments", width: 100, exportWidth: 15 },
        {title: "job title", key: "job_title", customClass : "", editable: true, type: "text", format: 7, selectOptionsKey: "", width: 230, exportWidth: 35 },
        {title: "job role", key: "job_role", customClass : "", editable: true, type: "select", format: 7, selectOptionsKey: "jobRoles", width: 300, exportWidth: 30 },
        {title: "manager", key: "manager_name", customClass : "", editable: true, type: "text", format: 7, selectOptionsKey: "", width: 150, exportWidth: 20 },
        {title: "date of hire", key: "hire_date", customClass : "", editable: true, type: "date", format: 7, selectOptionsKey: "", width: 140, exportWidth: 15 },
        {title: "date of \ntermination", key: "end_date", customClass : "", editable: true, type: "date", format: 7, selectOptionsKey: "", width: 150, exportWidth: 15 },
        {title: "involuntary /\n voluntary", key: "i_v", customClass : "", editable: true, type: "select", format: 7, selectOptionsKey: "voluntary", width: 140, exportWidth: 18 },
        {title: "regrettable /\n non regrettable", key: "r_nr", customClass : "", editable: true, type: "select", format: 7, selectOptionsKey: "regrettable", width: 140, exportWidth: 24 },
        {title: "term reason", key: "reason", customClass : "", editable: true, type: "select", format: 7, selectOptionsKey: "termReasons", width: 210, exportWidth: 25 },
        {title: "notes", key: "notes", customClass : "", editable: true, type: "text", format: 7, selectOptionsKey: "", width: 200, exportWidth: 40 },
        {title: "first year", key: "first_year", customClass : "", editable: false, type: "", format: 7, selectOptionsKey: "", width: 100, exportWidth: 15 },
        {title: "length of \nservice", key: "los", customClass : "", editable: false, type: "", format: 7, selectOptionsKey: "", width: 100, exportWidth: 15 }
    ];

    async function loadData() {
        if (loading) return;
        loading = true;
        reportData = null;
        const url = '/org/' + params.org + '/hr_censuses/' + currentPage + "/" + sortBy
        + "/" + order + "/" + entries + getSearch();
        let result = null;

        try {
            result = await ReportsService.load(url);
        } catch (e) {
            console.log('Error', e);
        }

        if (result && result.data) reportData = result.data;
        if (reportData && reportData.totalElements) totalElements = reportData.totalElements;
        loading = false;

        setTimeout(() => {
            tablesLoaded(true);
            enableTableSelection();
        }, 1000);
    }

    export const exportToExcel = async () => {
        loadingExport = true;
        try {
            const url = `/org/${params.org}/export/hr_censuses/0/id/true/1000`;
            const cencusReport = (await ReportsService.load(url)).data;
            const isFacilitator = !AuthService.can('EXPORT_HR_ALL_PORTCOS');
            const fileName = (!isFacilitator)? 'HR-Census':`HR-Census-${jQuery('#dropdownOrganizations').text()}`;
            if (!cencusReport && !cencusReport.totalElements) {
                alert('Nothing to export');
            } else {
                const headersToExport = [...headers];

                if (!isFacilitator) {
                    headersToExport.unshift({title: 'company', key: 'company', exportWidth: 24});
                }
                await ExportService.downloadCommonHrReport(
                    headersToExport,
                    cencusReport.terminationCensuses,
                    fileName,
                    'Census',
                    7,
                );
            }
        } catch (e) {
            console.log('Error', e);
        } finally {
            loadingExport = false;
        }
    };

    async function updateData(value, id, field){
        if(jQuery('.hr-pasting').length > 0){
            //Avoid save all the string pasted on the selected cell
            return false;
        }

        try {
            await ReportsService.updateCensusData({value, id, field});
        } catch (e) {
            console.log('Error', e);
        }
    }

    function getSearch(){
        return (search)? "/" + search : '';
    }

    export const onSearch = function(searchText){
        search = searchText;
    }

    function sort(key){
        //If it's a different column, set asc bt default. If not, set the opposite (asc = desc, desc = asc)
        order = (sortBy == key)? !order : true;
        sortBy = key;
    }

    export function selectEntries(entriesSelected){
        currentPage = 0;
        entries = entriesSelected;
    }

    let openJobRolesModal = function(){
        jQuery('#jobRolesModal').modal('show');
    }

    function openDeleteCensusModal(censusId){
        censusToDelete = censusId;
        jQuery('#deleteCensusConfirmation').modal('show');
    }

    async function deleteCensus(){
        try {
            await ReportsService.deleteCensus(censusToDelete);
            jQuery('#deleteCensusConfirmation').modal('hide');
            loadData();
        } catch (e) {
            console.log('Error', e);
        }
    }

    let onSaveCensus = async function() {
        let response = null;
        try {
            await ReportsService.saveCensus(currentCensus);
            loadData();
            jQuery('#addCensus').modal('hide');
            cleanCensus();
        } catch (e) {
            errorMessage = e.message;
            console.log(errorMessage);
        }
    }

    function cleanCensus() {
        currentCensus = {
            id: '',
            organization_id: params.org,
            employee_id: '',
            department: reportData.options.departments[0].value,
            job_title: '',
            notes: ''
        };
    }

    export const addRow = function(){
        cleanCensus();
        jQuery('#addCensus').modal('show');
    }

    //Import
    export const openImportModal = function(){
        jQuery('#importModal').modal('show');
    }

    let onImported = async function(){
        jQuery('#importModal').modal('hide');
        await loadData();
    }
</script>

<!-- Add census-->
<div class="modal fade" id="addCensus" tabindex="-1" role="dialog" aria-labelledby="addCensus" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="addEmployeeLabel">
                    Add Census
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form on:submit|preventDefault={onSaveCensus}>
                <div class="modal-body">
                    {#if AuthService.can('ADD_CENSUS') }
                        <div class="row">
                            <div class="col-md-12">
                                {#if reportData && reportData.options}
                                    <div class="form-group">
                                        <label for="candidate-req_id">*Employee #</label>
                                        <input  bind:value={currentCensus.employee_id} type="text" class="form-control" name="census-req_id" id="census-req_id" placeholder="100018">
                                    </div>
                                    <div class="form-group">
                                        <label for="staff-department">*Department</label>
                                        <select bind:value={currentCensus.department}  class="form-control" name="census-department" id="census-department">
                                            {#each reportData.options.departments as department}
                                                <option value="{department.value}">{department.option}</option>
                                            {/each}
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label for="nameInput">*Job Title</label>
                                        <input required bind:value={currentCensus.job_title} type="text" class="form-control" name="census-job_title" id="census-job_title" placeholder="Marketing Contractor">
                                    </div>
                                    <div class="form-group">
                                        <label for="staff-notes">Notes</label>
                                        <textarea bind:value={currentCensus.notes} type="text" class="form-control" id="census-notes" placeholder="Notes" rows="5"></textarea>
                                    </div>
                                {/if}
                            </div>
                        </div>
                    {/if}

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" on:click={cleanCensus}>Close</button>

                    <button type="submit" class="btn btn-success">
                        Save
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Delete census -->
<div class="modal fade" id="deleteCensusConfirmation" tabindex="-1" role="dialog" aria-labelledby="deleteCensusConfirmation" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteCensusLabel">
                    <i class="text-danger fa fa-exclamation-triangle ml-1"></i> WARNING!
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p>Are you sure you want to delete this position instead of
                enter a termination date?</p>
            </div>
            <div class="modal-footer text-right">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" >Cancel</button>
                <button type="button" class="btn btn-danger " on:click={() => deleteCensus()} >
                    Confirm
                </button>
            </div>
        </div>
    </div>
</div>

{#if loading}
    <Loader></Loader>
{:else}
    
    {#if AuthService.can('IMPORT_HR_REPORTS') }
        <HRImport params={params} module="censuses" on:imported={onImported}></HRImport>
    {/if}
    <JobRoles></JobRoles>
    <button class="d-none" id="reloadData" on:click={loadData}>RELOAD</button>
    <div class="table-wrapper hr-report">
        <table class="table table-sm container-fluid table-weekly selectable-table">
            <thead>
                <tr class="bg-dark text-light">
                    <th class="delete-cell"></th>
                    {#each headers as header, headerIndex}
                        <!-- <th style="min-width:{header.width}px" class="col-subheader {header.customClass}">{header.title}</th> -->
                        {#if header.editable}
                            <th
                              style="min-width: {header.width}px"
                              class="col-subheader {headerIndex > 3 ? 'notFixed' : '' } {header.customClass}">
                                <span class="pointer" on:click={() => sort(header.key)}>
                                    {header.title}
                                    <i class="fa fa-sort-{(sortBy == header.key && !order) ? 'desc' : 'asc' } {(sortBy == header.key) ? 'text-primary' : '' }"></i>
                                </span>
                                {#if header.key == 'job_role'}
                                    <i
                                        class="fa fa-info-circle ml-2 mr-1 vertical-middle pointer"
                                        on:click={ openJobRolesModal }
                                    ></i>
                                {/if}
                            </th>
                        {:else}
                             <th style="min-width: {header.width}px" class="col-subheader {headerIndex > 3 ? 'notFixed' : '' } {header.customClass}">{header.title}</th>
                        {/if}
                    {/each}
                </tr>
            </thead>
            <tbody>
                {#each reportData.terminationCensuses as terminationCensus, terminationCensusIndex}
                    <tr>
                        {#if AuthService.can('EDIT_STAFF') }
                            <th class="delete-cell">
                                <i
                                    class="fa fa-trash text-danger pointer"
                                    on:click={() => openDeleteCensusModal (terminationCensus.id)}
                                ></i>
                            </th>
                            {#each headers as header, column}
                                {#if header.editable}
                                    <td class="{column > 3 ? 'notFixed' : '' } readOnly hr-cell-border {( terminationCensus['end_date'] && ((header.key == 'i_v' && !terminationCensus[header.key]) ||
                                        (header.key == 'r_nr' && !terminationCensus[header.key])  || (header.key == 'reason' && !terminationCensus[header.key])) )?'cell-required':''} ">
                                        <EditableCell
                                            id="t1-{terminationCensusIndex}-{column}"
                                            on:change={(e) => updateData(e.detail.value, terminationCensus.id,  header.key)}
                                            bind:value={terminationCensus[header.key]}
                                            type={header.type}
                                            hrData="{ {census: terminationCensus.id, key: header.key, model: 'census', format: header.format} }"
                                            selectOptions={(header.type == "select" && reportData.options[header.selectOptionsKey]) ? reportData.options[header.selectOptionsKey] : []}
                                            customClass="hr-cell hr-cell-border" format={header.format}></EditableCell>
                                    </td>
                                {:else}
                                    <td class="readOnly {column > 3 ? 'notFixed' : '' }">{terminationCensus[header.key] || ''}</td>
                                {/if}
                            {/each}
                        {:else}
                            {#each headers as header, column}
                                <td class="readOnly {column > 3 ? 'notFixed' : '' }">{terminationCensus[header.key] || ''}</td>
                            {/each}
                        {/if}
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
    <Pagination {currentPage} {entries}  {totalElements} on:change={(e) => currentPage = e.detail.page} />
{/if}
